__turbopack_context__.v({
  "active": "TopMenu-module__V-qXlG__active",
  "menuBlock": "TopMenu-module__V-qXlG__menuBlock",
  "noMargin": "TopMenu-module__V-qXlG__noMargin",
  "topmenu": "TopMenu-module__V-qXlG__topmenu",
  "topmenuButton": "TopMenu-module__V-qXlG__topmenuButton",
  "topmenuButtonIcon": "TopMenu-module__V-qXlG__topmenuButtonIcon",
  "topmenuButtonLink": "TopMenu-module__V-qXlG__topmenuButtonLink",
  "topmenuItem": "TopMenu-module__V-qXlG__topmenuItem",
});
